"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IPcbLineShapeStyles = exports.FontStyle = exports.TextMirror = exports.TextAlignment = exports.TraceShapeType = exports.HoleMechanicalProcess = exports.LayerOrientation = exports.PcbLayoutShape = exports.PcbViaType = exports.PcbViaThermalReliefConductorAngle = exports.PcbViaThermalReliefConductors = exports.PcbViaThermalReliefTypes = exports.FootPrintPadHoleType = exports.PcbLayoutFootprintPadShape = void 0;
const structure_1 = require("../node/structure");
/**
 * When you need to define a type for any bakedRules, either using interface, enum
 * or type, define them below!
 */
var PcbLayoutFootprintPadShape;
(function (PcbLayoutFootprintPadShape) {
    PcbLayoutFootprintPadShape["circular"] = "circular";
    PcbLayoutFootprintPadShape["rectangle"] = "rectangle";
    PcbLayoutFootprintPadShape["octagonal"] = "octagonal";
    PcbLayoutFootprintPadShape["polygon"] = "polygon";
    PcbLayoutFootprintPadShape["custom"] = "custom";
})(PcbLayoutFootprintPadShape || (exports.PcbLayoutFootprintPadShape = PcbLayoutFootprintPadShape = {}));
var FootPrintPadHoleType;
(function (FootPrintPadHoleType) {
    FootPrintPadHoleType["platedThroughHole"] = "STD";
    FootPrintPadHoleType["SurfaceMountDevice"] = "SMD";
    FootPrintPadHoleType["testPinOrCardEdgeConnector"] = "CONN";
    FootPrintPadHoleType["nonPlatedHole"] = "HOLE";
})(FootPrintPadHoleType || (exports.FootPrintPadHoleType = FootPrintPadHoleType = {}));
var PcbViaThermalReliefTypes;
(function (PcbViaThermalReliefTypes) {
    PcbViaThermalReliefTypes["reliefConnect"] = "Relief connect";
    PcbViaThermalReliefTypes["directConnect"] = "Direct connect";
})(PcbViaThermalReliefTypes || (exports.PcbViaThermalReliefTypes = PcbViaThermalReliefTypes = {}));
var PcbViaThermalReliefConductors;
(function (PcbViaThermalReliefConductors) {
    PcbViaThermalReliefConductors["two"] = "2";
    PcbViaThermalReliefConductors["four"] = "4";
})(PcbViaThermalReliefConductors || (exports.PcbViaThermalReliefConductors = PcbViaThermalReliefConductors = {}));
var PcbViaThermalReliefConductorAngle;
(function (PcbViaThermalReliefConductorAngle) {
    PcbViaThermalReliefConductorAngle["fourtyFiveDegree"] = "45deg";
    PcbViaThermalReliefConductorAngle["nintyDegree"] = "90deg";
})(PcbViaThermalReliefConductorAngle || (exports.PcbViaThermalReliefConductorAngle = PcbViaThermalReliefConductorAngle = {}));
var PcbViaType;
(function (PcbViaType) {
    PcbViaType["throughHole"] = "throughHole";
    PcbViaType["microVia"] = "microVia";
    PcbViaType["buried"] = "buried";
    PcbViaType["blind"] = "blind";
})(PcbViaType || (exports.PcbViaType = PcbViaType = {}));
var PcbLayoutShape;
(function (PcbLayoutShape) {
    PcbLayoutShape["circular"] = "circular";
    PcbLayoutShape["rectangle"] = "rectangle";
    PcbLayoutShape["flux"] = "flux";
})(PcbLayoutShape || (exports.PcbLayoutShape = PcbLayoutShape = {}));
var LayerOrientation;
(function (LayerOrientation) {
    LayerOrientation["top"] = "Top";
    LayerOrientation["bottom"] = "Bottom";
    LayerOrientation["invert"] = "Invert";
})(LayerOrientation || (exports.LayerOrientation = LayerOrientation = {}));
var HoleMechanicalProcess;
(function (HoleMechanicalProcess) {
    HoleMechanicalProcess["drill"] = "drill";
    HoleMechanicalProcess["laser"] = "laser";
})(HoleMechanicalProcess || (exports.HoleMechanicalProcess = HoleMechanicalProcess = {}));
var TraceShapeType;
(function (TraceShapeType) {
    TraceShapeType["straight"] = "Straight";
    TraceShapeType["curve"] = "Curve";
})(TraceShapeType || (exports.TraceShapeType = TraceShapeType = {}));
var TextAlignment;
(function (TextAlignment) {
    TextAlignment["left"] = "left";
    TextAlignment["right"] = "right";
    TextAlignment["center"] = "center";
})(TextAlignment || (exports.TextAlignment = TextAlignment = {}));
var TextMirror;
(function (TextMirror) {
    TextMirror["none"] = "";
    TextMirror["mirror"] = "mirror";
})(TextMirror || (exports.TextMirror = TextMirror = {}));
var FontStyle;
(function (FontStyle) {
    FontStyle["normal"] = "normal";
    FontStyle["italic"] = "italic";
})(FontStyle || (exports.FontStyle = FontStyle = {}));
var IPcbLineShapeStyles;
(function (IPcbLineShapeStyles) {
    IPcbLineShapeStyles["dashed"] = "dashed";
    IPcbLineShapeStyles["solid"] = "solid";
})(IPcbLineShapeStyles || (exports.IPcbLineShapeStyles = IPcbLineShapeStyles = {}));
//# sourceMappingURL=structure.js.map